const routes = [
  {
    path: '/notifications',
    component: () => import(/* webpackChunkName: "Notifications" */ './components/notificationPane/NotificationPane.vue'),
  },
];
export default routes;
